export enum SupportedLocales {
    En = 'en',
    De = 'de',
    Jp = 'jp',
}
